import { Link } from "react-router-dom";
import { Inbox, ArrowRight } from "lucide-react";

export function UnassignedSection({ total }: { total: number }) {
  if (total === 0) return null;
  return (
    <Link
      to="/priorities?candidate=1"
      className="mt-8 flex items-center gap-3 rounded-xl border border-dashed border-amber-300/70 bg-amber-50/30 px-4 py-3 text-sm transition-colors hover:bg-amber-50/60 dark:border-amber-800/60 dark:bg-amber-950/10 dark:hover:bg-amber-950/20"
    >
      <Inbox className="h-4 w-4 text-amber-600" />
      <span className="font-semibold">Candidates</span>
      <span className="text-muted-foreground">· {total} deliverable{total === 1 ? "" : "s"} without a DRI or a PPP — nobody is on them yet</span>
      <ArrowRight className="ml-auto h-4 w-4 text-muted-foreground" />
    </Link>
  );
}
